import { render, staticRenderFns } from "./Courses2.vue?vue&type=template&id=1c830569&scoped=true&"
import script from "./Courses2.vue?vue&type=script&lang=js&"
export * from "./Courses2.vue?vue&type=script&lang=js&"
import style0 from "./Courses2.vue?vue&type=style&index=0&id=1c830569&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c830569",
  null
  
)

export default component.exports